import { render, staticRenderFns } from "./NestedTable.vue?vue&type=template&id=f2c65088&scoped=true"
import script from "./NestedTable.vue?vue&type=script&lang=js"
export * from "./NestedTable.vue?vue&type=script&lang=js"
import style0 from "./NestedTable.vue?vue&type=style&index=0&id=f2c65088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c65088",
  null
  
)

export default component.exports